<div class="grid grid-cols-1 divide-y" data-testid="umc-settings-popup">
  <div>
    <div class="flex items-center gap-x-2 px-4 pb-3" (click)="closeEvent.emit()">
      <kendo-avatar
        csPopupAnchorContent
        shape="circle"
        [imageSrc]="user()?.picture!"
        class="size-8 md:hidden"></kendo-avatar>
      <div class="flex flex-col gap-y-1">
        <span class="line-clamp-2 text-[16px]" data-testid="umc-user-username"
          >{{ user()?.firstName }} {{ user()?.lastName }}</span
        >
        @if (!isMoreThanOneRole() && firstRoleTitle()) {
          <span class="text-[12px] text-gray-500" data-testid="ums-user-role">{{ firstRoleTitle() }}</span>
        }
      </div>
    </div>
    @if (isMoreThanOneRole()) {
      <cs-user-menu-toggle [userRoleList]="validRoleList()" />
    }
    <a
      routerLink="/user-settings"
      class="hidden cursor-pointer items-center justify-between p-4 hover:bg-[#F3F4F6] md:flex"
      data-testid="umc-settings-button"
      (click)="closeEvent.emit()">
      <div class="flex items-center gap-x-2">
        <cs-icon size="large" name="gearOutline"></cs-icon>
        <span class="text-[14px] font-normal">Settings</span>
      </div>
    </a>
    <cs-toggle-menu
      [menuProps]="subItemsUserSettings"
      (closeDrawerEvent)="closeEvent.emit()"
      class="block md:hidden"></cs-toggle-menu>
    <a
      [href]="feedbackUrl"
      target="_blank"
      class="flex items-center justify-between p-4 hover:bg-[#F3F4F6]"
      data-testid="umc-feedback-anchor">
      <div class="flex items-center gap-x-2">
        <cs-icon size="large" name="openInNew"></cs-icon>
        <span class="line-clamp-2 text-[14px] font-normal"> Submit Feedback </span>
      </div>
    </a>
  </div>
  <div (click)="closeEvent.emit()">
    <div class="px-4 py-3">
      <div class="flex flex-col gap-y-1">
        <span class="line-clamp-2 text-[14px] font-medium">Contact</span>
        <a
          class="line-clamp-2 text-[14px]"
          data-testid="umc-contact-email"
          href="mailto:{{ contactInfo.email.value }}"
          >{{ contactInfo.email.value }}</a
        >
        <a class="line-clamp-2 text-[14px]" href="tel:+{{ contactInfo.phone.value }}">{{ contactInfo.phone.string }}</a>
      </div>
    </div>
  </div>
  <div (click)="closeEvent.emit()">
    <button
      type="button"
      class="flex w-full items-center justify-between p-4 hover:bg-[#F3F4F6]"
      (click)="handleLogout()"
      data-testid="umc-logout-button">
      <div class="flex flex-col gap-y-1">
        <span class="line-clamp-2 text-[14px]">Log Out</span>
      </div>
    </button>
  </div>
</div>
